/* Mindset Media Group Research Intake v1.0.0 */
(()=>{'use strict';
const RELAY='https://mindset-research-intake-relay-fxhc2h.v2.appdeploy.ai';
const forms=[...document.querySelectorAll('.mmg-research-form[data-research-study]')];
if(!forms.length)return;
const numeric=new Set(['weekly_content_hours','weekly_admin_hours','manual_hours_before','hours_after_ai','review_share_percent','perceived_reliability','rework_hours_per_title','metadata_confidence']);
const multi={creator:['monetization_mix'],'ai-workflow':['controls_used'],'digital-publishing':['publication_type']};
const message=(form,state,text)=>{const node=form.querySelector('.research-status');if(!node)return;node.dataset.state=state;node.textContent=text};
const values=(form,name)=>[...form.querySelectorAll('input[name="'+name+'"]:checked')].map(input=>input.value);
forms.forEach(form=>{
  form.dataset.startedAt=String(Date.now());
  form.addEventListener('submit',async event=>{
    event.preventDefault();
    const study=form.dataset.researchStudy;
    if(!study)return;
    message(form,'','');
    if(!form.reportValidity()){message(form,'error','Please complete every required field.');return}
    const requiredMulti=multi[study]||[];
    for(const name of requiredMulti){if(!values(form,name).length){message(form,'error','Please choose at least one option in each multi-select question.');return}}
    const data=new FormData(form);
    const payload={honeypot:String(data.get('website')||''),consent:data.get('consent')==='yes',eligible:data.get('eligible')==='yes',started_at_ms:Number(form.dataset.startedAt||Date.now())};
    for(const [key,value] of data.entries()){
      if(['website','consent','eligible'].includes(key)||requiredMulti.includes(key))continue;
      payload[key]=numeric.has(key)?Number(value):String(value);
    }
    requiredMulti.forEach(name=>{payload[name]=values(form,name)});
    const button=form.querySelector('.research-submit');
    if(button){button.disabled=true;button.setAttribute('aria-busy','true')}
    message(form,'','Submitting…');
    const controller=new AbortController();
    const timer=setTimeout(()=>controller.abort(),15000);
    try{
      const response=await fetch(RELAY+'/api/research/'+encodeURIComponent(study),{method:'POST',mode:'cors',credentials:'omit',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload),signal:controller.signal});
      let body={};try{body=await response.json()}catch(_){}
      if(!response.ok)throw new Error(body.message||body.error||'submission_failed');
      form.reset();
      form.dataset.startedAt=String(Date.now());
      form.dataset.submitted='true';
      message(form,'success','Thank you. Your research response has been recorded.');
    }catch(error){
      const unavailable=error?.name==='AbortError'||String(error?.message||'').includes('unavailable')||String(error?.message||'').includes('configured');
      message(form,'error',unavailable?'Research intake is temporarily unavailable. Please try again shortly.':'We could not record this response. Check the fields and try again.');
    }finally{
      clearTimeout(timer);
      if(button){button.disabled=false;button.removeAttribute('aria-busy')}
    }
  });
});
})();